import { render } from "./IconGlobe.vue?vue&type=template&id=78f25c64"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconGlobe.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78f25c64"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78f25c64', __exports__)) {
    api.reload('78f25c64', __exports__)
  }
  
  module.hot.accept("./IconGlobe.vue?vue&type=template&id=78f25c64", () => {
    api.rerender('78f25c64', render)
  })

}


export default __exports__